
import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { TaskActionsComponent } from '../../task-actions/task-actions.component';
import { Task, TaskAction } from '../../taskbook.types';
import { CommonModule } from "@angular/common";

@Component({
  selector: 'task-success-dialog',
  templateUrl: './task-success-dialog.component.html',
  styleUrls: ['./task-success-dialog.component.scss', './../../task/task.component.scss'],
    standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    TranslateModule,
    MatDialogModule,
    MatDialogTitle,
    MatDialogContent,
    TaskActionsComponent
]
})
export class TaskSucessDialogComponent implements OnInit {

  currentTask: Task;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TaskSuccessDialogData,
    private dialogRef: MatDialogRef<TaskSucessDialogComponent, TaskSuccessDialogCloseData>,
  ) { }

  ngOnInit(): void {
    this.currentTask = this.data.task;
  }

  action(data: {task: Task, action: TaskAction}){
    this.dialogRef.close({task: data.task, action: data.action});
  }
}

interface TaskSuccessDialogData{
  task: Task,
}

interface TaskSuccessDialogCloseData{
  task: Task,
  action: TaskAction
}